import { RouteObject } from 'react-router-dom';
import MainLayout from '@/components/layouts/MainLayout.tsx';
import AuthorizationLayout from '@/components/layouts/AuthorizationLayout';
import DashboardPage from '@/features/dashboard/DashboardPage.tsx';
import OwnersPage from '@/features/owners/OwnersPage.tsx';
import OrdersPage from '@/features/orders/OrdersPage';
import FaqPage from '@/features/faq/FaqPage.tsx';
import SettingsPage from '@/features/settings/SettingsPage.tsx';
import NotificationsPage from '@/features/notifications/NotificationsPage.tsx';
import ApartmentsPage from '@/features/apartments/ApartmentsPage';
import CalendarPage from '@/features/calendar/CalendarPage';
import FinancesPage from '@/features/finances/FinancesPage';
import TransactionsPage from '@/features/transactions/TransactionsPage';
import AccountPage from '@/features/account/AccountPage';
import ProtectedRoute from '@/components/auth/ProtectedRoute.tsx';
import NewsAndOffersPage from '@/features/news-and-offers/NewsAndOffersPage';
import LoginPage from '@/features/identity/LoginPage.tsx';
import ForgotPasswordPage from '@/features/identity/ForgotPasswordPage.tsx';
import SetPasswordPage from '@/features/identity/SetPasswordPage.tsx';
import NewPasswordPage from '@/features/identity/NewPasswordPage.tsx';
import AuthorizationMessagePage from '@/features/identity/AuthorizationMessagePage.tsx';
import TwoFactorLogin from '@/features/identity/TwoFactorLogin';
import ChooseHotelPage from '@/features/identity/ChooseHotelPage.tsx';
import PrivacyPolicy from '@/features/identity/components/other/PrivacyPolicy';
import TermsOfService from '@/features/identity/components/other/TermsOfService';
import SignUpPage from '@/features/identity/SignUpPage';
import RegistrationConfirmPage from '@/features/identity/RegistrationConfirmPage';
import SuperAdminDashboardPage from '@/features/superAdmin/features/dashboard/SuperAdminDashboardPage';
import SuperAdminTenantsPage from '@/features/superAdmin/features/tenants/SuperAdminTenantsPage';
import SuperAdminUsersPage from '@/features/superAdmin/features/users/SuperAdminUsersPage';
import SuperAdminUserActivitiesPage from '@/features/superAdmin/features/userActivities/SuperAdminUserActivitiesPage';
import SupportEmailRequestsListPage from '@/features/superAdmin/features/supportEmailRequests/SupportEmailRequestsListPage';
import SupportEmailRequestDetailPage from '@/features/superAdmin/features/supportEmailRequests/SupportEmailRequestDetailPage';
import SuperAdminDataHubPage from '@/features/superAdmin/features/data/SuperAdminDataHubPage';
import SuperAdminBookingsListPage from '@/features/superAdmin/features/data/bookings/SuperAdminBookingsListPage';
import SuperAdminBookingDetailPage from '@/features/superAdmin/features/data/bookings/SuperAdminBookingDetailPage';
import SuperAdminOrdersListPage from '@/features/superAdmin/features/data/orders/SuperAdminOrdersListPage';
import SuperAdminOwnersListPage from '@/features/superAdmin/features/data/owners/SuperAdminOwnersListPage';
import SuperAdminOwnerDetailPage from '@/features/superAdmin/features/data/owners/SuperAdminOwnerDetailPage';
import SuperAdminRoomsListPage from '@/features/superAdmin/features/data/rooms/SuperAdminRoomsListPage';
import SuperAdminRoomDetailPage from '@/features/superAdmin/features/data/rooms/SuperAdminRoomDetailPage';
import SuperAdminRentChargesListPage from '@/features/superAdmin/features/data/rentCharges/SuperAdminRentChargesListPage';
import SuperAdminRentChargeDetailPage from '@/features/superAdmin/features/data/rentCharges/SuperAdminRentChargeDetailPage';
import InboxMessagesListPage from '@/features/superAdmin/features/integrationMessages/inbox/InboxMessagesListPage';
import InboxMessageDetailPage from '@/features/superAdmin/features/integrationMessages/inbox/InboxMessageDetailPage';
import OutboxMessagesListPage from '@/features/superAdmin/features/integrationMessages/outbox/OutboxMessagesListPage';
import OutboxMessageDetailPage from '@/features/superAdmin/features/integrationMessages/outbox/OutboxMessageDetailPage';
import InternalOutboxMessagesListPage from '@/features/superAdmin/features/integrationMessages/internalOutbox/InternalOutboxMessagesListPage';
import InternalOutboxMessageDetailPage from '@/features/superAdmin/features/integrationMessages/internalOutbox/InternalOutboxMessageDetailPage';
import EmailOutboxMessagesListPage from '@/features/superAdmin/features/integrationMessages/emailOutbox/EmailOutboxMessagesListPage';
import EmailOutboxMessageDetailPage from '@/features/superAdmin/features/integrationMessages/emailOutbox/EmailOutboxMessageDetailPage';
import PlatformGeneralSettingsPage from '@/features/superAdmin/features/settings/PlatformGeneralSettingsPage';
import AppAiSettingsPage from '@/features/superAdmin/features/settings/AppAiSettingsPage';
import DashboardPageRouter from '@/features/dashboard/components/DashboardPageRouter';
import SignUpConfirmPage from '@/features/identity/SignUpConfirmPage';
import ReleasesPage from '@/features/releases/ReleasesPage';
import PaymentResultPage from '@/features/payments/PaymentResultPage';
import MaintenancePage from '@/features/maintenance/MaintenancePage';
import { MaintenanceGuard } from '@/features/maintenance/components/MaintenanceGuard';

export const routes: RouteObject[] = [
    {
        element: <MaintenanceGuard />,
        children: [
            {
                path: '/auth/login',
                element: (
                    <AuthorizationLayout>
                        <LoginPage />
                    </AuthorizationLayout>
                ),
            },
            {
                path: '/auth/forgot-password',
                element: (
                    <AuthorizationLayout>
                        <ForgotPasswordPage />
                    </AuthorizationLayout>
                ),
            },
            {
                path: '/auth/sign-up',
                element: (
                    <AuthorizationLayout>
                        <SignUpPage />
                    </AuthorizationLayout>
                ),
            },
            {
                path: '/auth/registration-confirm',
                element: (
                    <AuthorizationLayout>
                        <RegistrationConfirmPage />
                    </AuthorizationLayout>
                ),
            },
            {
                path: '/auth/sign-up-confirm',
                element: (
                    <AuthorizationLayout>
                        <SignUpConfirmPage />
                    </AuthorizationLayout>
                ),
            },
            {
                path: '/auth/set-password/:token',
                element: (
                    <AuthorizationLayout>
                        <SetPasswordPage />
                    </AuthorizationLayout>
                ),
            },
            {
                path: '/auth/new-password',
                element: (
                    <AuthorizationLayout>
                        <NewPasswordPage />
                    </AuthorizationLayout>
                ),
            },
            {
                path: '/auth/message/:type',
                element: (
                    <AuthorizationLayout>
                        <AuthorizationMessagePage />
                    </AuthorizationLayout>
                ),
            },
            {
                path: '/auth/two-factor-login',
                element: (
                    <AuthorizationLayout>
                        <TwoFactorLogin />
                    </AuthorizationLayout>
                ),
            },
            {
                path: '/auth/choose-hotel',
                element: (
                    <AuthorizationLayout>
                        <ChooseHotelPage />
                    </AuthorizationLayout>
                ),
            },
            {
                path: '/',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <DashboardPageRouter />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/dashboard',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <DashboardPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/owners',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <OwnersPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/orders',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <OrdersPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/notifications',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <NotificationsPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/faqs',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <FaqPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/settings',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SettingsPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/apartments',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <ApartmentsPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/calendar',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <CalendarPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/finances',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <FinancesPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/finances/transactions',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <TransactionsPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/account',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <AccountPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/news-and-offers',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <NewsAndOffersPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/payment-success',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <PaymentResultPage success={true} />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/payment-failed',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <PaymentResultPage success={false} />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/privacy-policy',
                element: (
                    <AuthorizationLayout>
                        <PrivacyPolicy />
                    </AuthorizationLayout>
                ),
            },
            {
                path: '/terms-of-service',
                element: (
                    <AuthorizationLayout>
                        <TermsOfService />
                    </AuthorizationLayout>
                ),
            },
            {
                path: '/maintenance',
                element: (
                    <AuthorizationLayout>
                        <MaintenancePage />
                    </AuthorizationLayout>
                ),
            },
            {
                path: '/superAdmin/dashboard',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SuperAdminDashboardPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/tenants',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SuperAdminTenantsPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/users',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SuperAdminUsersPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/user-activities',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SuperAdminUserActivitiesPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/releases',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <ReleasesPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/support-requests',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SupportEmailRequestsListPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/support-requests/:id',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SupportEmailRequestDetailPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SuperAdminDataHubPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/bookings',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SuperAdminBookingsListPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/bookings/:id',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SuperAdminBookingDetailPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/orders',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SuperAdminOrdersListPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/owners',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SuperAdminOwnersListPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/owners/:id',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SuperAdminOwnerDetailPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/rooms',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SuperAdminRoomsListPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/rooms/:id',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SuperAdminRoomDetailPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/rent-charges',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SuperAdminRentChargesListPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/rent-charges/:id',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <SuperAdminRentChargeDetailPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/inbox',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <InboxMessagesListPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/inbox/:id',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <InboxMessageDetailPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/outbox',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <OutboxMessagesListPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/outbox/:id',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <OutboxMessageDetailPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/internal-outbox',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <InternalOutboxMessagesListPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/internal-outbox/:id',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <InternalOutboxMessageDetailPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/email-outbox',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <EmailOutboxMessagesListPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/data/email-outbox/:id',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <EmailOutboxMessageDetailPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/settings/general',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <PlatformGeneralSettingsPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
            {
                path: '/superAdmin/settings/ai',
                element: (
                    <ProtectedRoute>
                        <MainLayout>
                            <AppAiSettingsPage />
                        </MainLayout>
                    </ProtectedRoute>
                ),
            },
        ],
    },
];
